import Model from "../../Model.js";

/**
 * Abstract superclass for whether or not an account row should be visible
 * in a report.
 *
 * @abstract
 */
class AbstractAccountVisibility extends Model {
	getLabel() {
		return this.constructor.getLabel();
	}

	/**
	 * @return {boolean} Whether the accountRow should be rendered in the
	 * report.
	 */
	isVisible(_accountRow) {
		return this._subclassResponsibility();
	}

	/**
	 * @return {boolean} Whether some accounts may be visible at all when using
	 * the receiver to compute account visibility.
	 */
	showsSomeAccounts() {
		return true;
	}

	matches(visibility) {
		return this === visibility;
	}

	static getLabel() {
		return "";
	}

	static instance() {
		this._instance ||= new this();

		return this._instance;
	}
}

export default AbstractAccountVisibility;
